/**
 * Generate a URL-friendly slug from a string.
 * e.g. "The Badminton Collective" → "the-badminton-collective"
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')                     // decompose accents
    .replace(/[\u0300-\u036f]/g, '')      // remove diacritics
    .replace(/[^a-z0-9]+/g, '-')          // replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, '')              // trim leading/trailing hyphens
    .replace(/-{2,}/g, '-')               // collapse multiple hyphens
}




